export default "__VITE_ASSET__484da69a__"